import React, { Component } from 'react';
import { Redirect, Switch, Link, BrowserRouter, Route } from 'react-router-dom'
import Auth from './Auth';
import history from '../history';
import axios from 'axios';
import Autocomplete from 'react-autocomplete';


export default class Libr extends React.Component {

    constructor(props) {
        super(props);

        this.inputFio = this.inputFio.bind(this);
        this.inputTitle = this.inputTitle.bind(this);
        this.inputType = this.inputType.bind(this);
        this.inputSubtype = this.inputSubtype.bind(this);
        this.inputCountAuthor = this.inputCountAuthor.bind(this);
        this.inputCountPageMin = this.inputCountPageMin.bind(this);
        this.inputCountPageMax = this.inputCountPageMax.bind(this);
        this.setDefaultPps = this.setDefaultPps.bind(this);
        this.replacePps = this.replacePps.bind(this);

        this.submit = this.submit.bind(this);
        this.addBook = this.addBook.bind(this);
        this.removeBook = this.removeBook.bind(this);
        this.setIndexRow = this.setIndexRow.bind(this);
        this.getPosition = this.getPosition.bind(this);


        this.state = {
            fio: '',
            countBook: 1,
            index: 0,
            listBook:[
                {
                    'id_book': 0,
                    'title': '',
                    'type': 'Статья',
                    'subtype_1': 0,
                    'subtype_2': 0,
                    'subtype_3': 0,
                    'countAuthor': 0,
                    'countPageMin': 0,
                    'countPageMax': 0
                }
            ],
            listFio: [],
            positionIsLoaded: false,
            position: '',
            status: '',
            isReplace: false
        };
    };

    setDefaultPps(){

        let pps = this.props.defaultPps

        this.setState({
            id_pps: pps.id_pps,
            fio: pps.fio,
            listBook:[
                {
                    'id_book': 0,
                    'title': pps.title,
                    'type': pps.type,
                    'subtype_1': pps.subtype_1,
                    'subtype_2': pps.subtype_2,
                    'subtype_3': pps.subtype_3,
                    'countAuthor': pps.countAuthor,
                    'countPageMin': pps.countPageMin,
                    'countPageMax': pps.countPageMax
                }
            ],
            isReplace: true
        })
    }

    inputFio(e){
        this.setState({
            fio: e.target.value
        })
    }

    inputTitle(e){
        let value = e.target.value;
        let index = this.state.index;
        let cur = this.state.listBook;
//        console.log(cur);
        cur[index].title = value;
        this.setState({
            listBook: cur
        })
    }

    inputType(e){
        let value = e.target.value;
        let index = this.state.index;
        let cur = this.state.listBook;

        cur[index].type = value;
        this.setState({
            listBook: cur
        })
    }

    inputSubtype(index, subtype){

        let cur = this.state.listBook;
        console.log(cur);
        if(subtype == 1){
            if(cur[index].subtype_1 == 0){
                cur[index].subtype_1 = 1;
            }else{
                cur[index].subtype_1 = 0;
            }
        }
        if(subtype == 2){
            if(cur[index].subtype_2 == 0){
                cur[index].subtype_2 = 1;
            }else{
                cur[index].subtype_2 = 0;
            }
        }
        if(subtype == 3){
            if(cur[index].subtype_3 == 0){
                cur[index].subtype_3 = 1;
            }else{
                cur[index].subtype_3 = 0;
            }
        }
        this.setState({
            listBook: cur
        })

    }

    inputCountAuthor(e){
        let value = e.target.value;
        let index = this.state.index;
        let cur = this.state.listBook;
        console.log(cur);
        cur[index].countAuthor = value;
        this.setState({
            listBook: cur
        })
    }

    inputCountPageMin(e){
        let value = e.target.value;
        let index = this.state.index;
        let cur = this.state.listBook;
        console.log(cur);
        cur[index].countPageMin = value;
        this.setState({
            listBook: cur
        })
    }

    inputCountPageMax(e){
        let value = e.target.value;
        let index = this.state.index;
        let cur = this.state.listBook;
        console.log(cur);
        cur[index].countPageMax = value;
        this.setState({
            listBook: cur
        })
    }

    submit(){
        let fio = this.state.fio;
        let listBook = this.state.listBook;
        let data = {
            "fio": fio,
            "listBook": listBook
        }
        console.log('ВЫ ОТПРАВИЛИ');
        console.log(data);
        data = JSON.stringify(data);
        axios
          .get("/server/addPps.php?data="+data)
          .then((result) => {

            let id_pps = result.data;
            console.log('С сервера вернулось id_pps: '+id_pps);
            id_pps = parseInt(id_pps);
            //обновление шаблона
            this.setState({
                fio: '',
                listBook:[
                    {
                        'id_book': 0,
                        'title': '',
                        'type': 'Статья',
                        'subtype_1': 0,
                        'subtype_2': 0,
                        'subtype_3': 0,
                        'countAuthor': 0,
                        'countPageMin': 0,
                        'countPageMax': 0
                    }
                ]
            })
            if(id_pps > -1){
                this.setState({
                    status: 'Данные успешно отправлены'
                })
            } else {
                this.setState({
                    status: 'Ошибка: данные не были добавлены'
                })
            }
            //скрытие уведомления
              setTimeout(() => {
                this.setState({
                  status: ''
                })
              },2000)

          });
    }

    addBook(){
        console.log('------------------------');
        this.setState({
            countBook: this.state.countBook+1
        })
        this.state.listBook.push({
            'id_book': this.state.countBook,
            'title': '',
            'type': 'Статья',
            'subtype_1': 0,
            'subtype_2': 0,
            'subtype_3': 0,
            'countAuthor': 0,
            'countPageMin': 0,
            'countPageMax': 0
        })
    }

    removeBook(){
        console.log('------------------------');
        if(this.state.listBook.length > 1){
            this.setState({
                countBook: this.state.countBook-1
            })
            this.state.listBook.pop()
        }
    }

    setIndexRow(index){
        this.setState({
            index: index
        })
    }

    //не закончена
    getPosition(e){
        let value = e.target.value;
        //получение должности по фамилии
        let data = value;
       axios
          .get("/server/getPosition.php?data="+data)
          .then((result) => {

            let position = result.data;
            console.log(position);

            this.setState({
                positionIsLoaded: true,
                position: result.data
            });
          });
    }

    replacePps(){
      let id_pps = this.state.id_pps;
      let fio = this.state.fio;
      let listBook = this.state.listBook;
      let data = {
          "id_pps": id_pps,
          "fio": fio,
          "listBook": listBook
      }
      //console.log('ВЫ ОТПРАВИЛИ ДЛЯ ИЗМЕНЕНИЯ');
      //console.log(data);
      data = JSON.stringify(data);
      axios
        .get("/server/replacePps.php?data="+data)
        .then((result) => {

          let id_pps = result.data;
          console.log('С сервера вернулось id_pps: '+id_pps);
          id_pps = parseInt(id_pps);
          //обновление шаблона
          this.setState({
              fio: '',
              listBook:[
                  {
                      'id_book': 0,
                      'title': '',
                      'type': 'Статья',
                      'subtype_1': 0,
                      'subtype_2': 0,
                      'subtype_3': 0,
                      'countAuthor': 0,
                      'countPageMin': 0,
                      'countPageMax': 0
                  }
              ],
              isReplace: false
          })
          if(id_pps == this.state.id_pps){
              this.setState({
                  status: 'Данные успешно изменены'
              })
          } else {
              this.setState({
                  status: 'Ошибка: данные не были изменены'
              })
          }
          //скрытие уведомления
            setTimeout(() => {
              this.setState({
                status: ''
              })
              window.location.href = "/";
            },2000)

        });
    }

    componentDidMount() {
        this.setDefaultPps();
    }

    componentWillMount(){
    //получение списка ФИО
       axios
          .get("/server/getListFio.php")
          .then((result) => {

            let list = result.data;
            list.pop();
            //console.log(list);

            this.setState({
                listFioIsLoaded: true,
                listFio: result.data
            });
          });

        /*
        //получение должности по фамилии
        axios.post('/server/api.php', {
          func: 'getPositionByFio',
          data: 'gogog'
        })
        .then(
          (res) => {
            this.setState({
                positionIsLoaded: true,
                position: res.data
            });
              console.log(res.data);
          }
        )
        .catch(function (error) {
        console.log(error);
        });*/
    }

    render() {
        if( this.props.role == 'libr' ){

          let style = {
            opacity: this.state.isReplace
          }
          let replaceButton = <div className='replace-button' style={style} onClick={this.replacePps}>Изменить</div>

          /*
            if( this.state.isReplace ){
              const replaceButton =
                return (
                  <div className='replace-button' onClick={this.replacePps}>replace</div>
                )

            }
*/
            //книги
            const list = this.state.listBook.map((book, index) => {
                //console.log(book);
                return (
                    <div key={book.id_book} className='one-book'>
                        {/*     название    */}
                        <input
                            placeholder='Название публикации'
                            className='input-title'
                            onFocus={()=>this.setIndexRow(index)}
                            onChange={this.inputTitle}
                            value={this.state.listBook[index].title}
                        />
                        {/*     тип     */}
                        <select
                            className='input-type'
                            onFocus={()=>this.setIndexRow(index)}
                            onChange={this.inputType}
                            value={this.state.listBook[index].type}
                        >
                          <option value="Статья">Статья</option>
                          <option value="Монография">Монография</option>
                          <option value="Учебное пособие">Учебное пособие</option>
                          <option value="Учебно-методическое пособие">Учебно-методическое пособие</option>
                          <option value="Патент">Патент</option>
                          <option value="Программа ЭВМ">Программа ЭВМ</option>
                        </select>
                        {/*     подтип      */}
                        <div className='input-subtype-1' onClick={() => {this.inputSubtype(index, 1)}}>{this.state.listBook[index].subtype_1}</div>
                        <div className='input-subtype-2' onClick={() => {this.inputSubtype(index, 2)}}>{this.state.listBook[index].subtype_2}</div>
                        <div className='input-subtype-3' onClick={() => {this.inputSubtype(index, 3)}}>{this.state.listBook[index].subtype_3}</div>
                        {/*
                        <select
                            className='input-subtype'
                            onFocus={()=>this.setIndexRow(index)}
                            onChange={this.inputSubtype}
                            value={this.state.listBook[index].subtype}
                        >
                          <option value=""></option>
                          <option value="ВАК">ВАК</option>
                          <option value="Scopus">Scopus</option>
                          <option value="WS">WS</option>
                        </select>
                        */}
                        {/*     кол-во авторов    */}
                        <input
                            className='input-count-author'
                            onFocus={()=>this.setIndexRow(index)}
                            onChange={this.inputCountAuthor}
                            value={this.state.listBook[index].countAuthor}
                            type='number'
                        />
                        {/*     мин кол-во стр    */}
                        <input
                            className='input-page-min'
                            onFocus={()=>this.setIndexRow(index)}
                            onChange={this.inputCountPageMin}
                            value={this.state.listBook[index].countPageMin}
                            type='number'
                        />
                        {/*     макс кол-во стр    */}
                        <input
                            className='input-page-max'
                            onFocus={()=>this.setIndexRow(index)}
                            onChange={this.inputCountPageMax}
                            value={this.state.listBook[index].countPageMax}
                            type='number'
                        />
                    </div>
                );
            });

            return (
            <div className='libr'>
                <Link className='link' to="/libr">Форма заполнения</Link>
                <Link className='link' to="/librstat">Статистика</Link>
                <div className='status-block'>{this.state.status}</div>
                <div className='fio-block'>
                <div className='title'>ФИО</div>
                <Autocomplete
                    items={this.state.listFio}
                    shouldItemRender={(item, value) => item.toLowerCase().indexOf(value.toLowerCase()) > -1}
                    getItemValue={item => item}
                    renderItem={(item, highlighted) =>
                      <div
                        key={item.id}
                        style={{ backgroundColor: highlighted ? '#eee' : 'transparent'}}
                      >
                        {item}
                      </div>
                    }
                    value={this.state.fio}
                    onChange={e => this.setState({ fio: e.target.value })}
                    onSelect={value => this.setState({ fio: value })}
                />

                </div>
                <div className='list-block'>
                    <div className='addBook-button' onClick={this.addBook}>+</div>
                    <div className='removeBook-button' onClick={this.removeBook}>-</div>
                <div className='label-block'>
                  <div className='label l1'>Название публикации</div>
                  <div className='label l2'>Тип</div>
                  <div className='label l3'>ВАК</div>
                  <div className='label l4'>Scop</div>
                  <div className='label l5'>WS</div>
                  <div className='label l6'>Соавторов</div>
                  <div className='label l7'>От</div>
                  <div className='label l8'>По</div>
                </div>
                {list}
                </div>
                <div className='submit-button' onClick={this.submit}>Отправить</div>
                {replaceButton}
            </div>
            );
        } else {
            history.push('/auth');
            return ('');
        }
    }
}



// WEBPACK FOOTER //
// ./src/component/Libr.js